module.exports = __webpack_public_path__ + "media/餐馆.895d7db6.wav";